// extracted by mini-css-extract-plugin
export default {"container":"Ads_container__+wi0P","smallContainer":"Ads_smallContainer__1EPTL","title":"Ads_title__MNRyc","titleColor":"Ads_titleColor__PND6g","subTitle":"Ads_subTitle__mpq6T"};